import apiService from './api';

export interface Product {
  id: string;
  nom: string;
  type: string;
  description?: string;
}

export interface ProductOption {
  value: string;
  label: string;
}

class ProductsService {
  /**
   * Charger tous les produits
   */
  async getProducts(): Promise<ProductOption[]> {
    try {
      const response = await apiService.get('/weighing/api/produits/');
      return response.data.results?.map((product: any) => ({
        value: product.id.toString(),
        label: `${product.nom} - ${product.type}`
      })) || [];
    } catch (error) {
      console.error('Erreur lors du chargement des produits:', error);
      return [];
    }
  }

  /**
   * Charger un produit par ID
   */
  async getProduct(id: string): Promise<Product | null> {
    try {
      const response = await apiService.get(`/weighing/api/produits/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors du chargement du produit:', error);
      return null;
    }
  }
}

export default new ProductsService();
